module.exports = { 
      attributes: {"title":"Europäische Meisterschaft 2021","date":"2021-07-03T00:00:00.000Z","author":"Richi","categories":["news"],"tags":["news"],"language":"de","section":null},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = function render() { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0) };
            this.$options.staticRenderFns = [function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-body"},[_c('p',[_vm._v("Die Anmeldung für die diesjährige Europameisterschaft ist eröffnet.")]),_vm._v(" "),_c('p',[_vm._v("Die ESC/WOSC wird in diesem Jahr in Minsk ausgetragen.\nBitte beachten Sie die Einreisebestimmungen des Landes,\num die Quarantäne zu vermeiden.")]),_vm._v(" "),_c('p',[_vm._v("Die Anmeldung kann "),_c('a',{attrs:{"href":"http://euro2020.shogi.by/en/"}},[_vm._v("hier")]),_vm._v(" erfolgen.")])]) }];
          }
        }
      },
     }